require("dotenv").config();
const END_POINT_URL = process.env.REACT_APP_END_POINT_URL;
const REPORTING_SERVICE = process.env.REACT_APP_REPORTING_SERVICE;
module.exports = { END_POINT_URL, REPORTING_SERVICE };
